import { storePagination } from '@/mixins/store'
import axios from '@axios'
import moment from 'moment'

export const getDefaultPurchaseItemForReferenceFilter = () => ({
  id: null,
  supplierId: null,
  invoiceNumber: '',
  invoiceDate: {
    startDate: moment().add(-45, 'days').startOf('day').format(),
    endDate: moment().endOf('day').format(),
  },
})

const getInitialState = () => ({
  ...storePagination.state(),
  purchaseOrdersForInvoiceReference: [],
  filters: getDefaultPurchaseItemForReferenceFilter(),
})

export default {
  namespaced: true,

  state: getInitialState(),

  getters: {},

  mutations: {
    ...storePagination.mutations,

    SET_ORDER_PURCHASES(state, purchaseOrdersForInvoiceReference) {
      state.purchaseOrdersForInvoiceReference = purchaseOrdersForInvoiceReference
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },

    CLEAN_STATE(state) {
      const defaultData = getInitialState()
      Object.keys(defaultData).forEach(key => {
        state[key] = defaultData[key]
      })
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchOrderPurchaseForInvoiceReference({ commit, state }, { storeId, skuId }) {
      const {
        id,
        supplierId,
        invoiceNumber,
        invoiceDate,
      } = state.filters

      const { data } = await axios.get(`/api/purchases/available-for-invoice-return/store/${storeId}/sku/${skuId}`, {
        params: {
          id,
          supplierId,
          invoiceNumber,
          invoiceDateFrom: invoiceDate.startDate,
          invoiceDateTo: invoiceDate.endDate,
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: 'InvoiceDate DESC',
        }
      })

      commit('SET_ORDER_PURCHASES', data.results)
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount,
        rowsInCurrentPage: data.rowsInCurrentPage,
      })

      return data
    },

    setFilters({ commit }, filters) {
      commit('SET_FILTERS', filters)
    },

    setCurrentPage({ commit }, currentPage) {
      commit('SET_CURRENT_PAGE', currentPage)
    },

    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
